import {inject, Injectable} from '@angular/core';
import {Platform} from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private platform = inject(Platform);

  readonly isMobile: boolean = this.platform.is('mobile') && !this.platform.is('ipad') &&
    !this.platform.is('tablet');
  readonly isPWA: boolean = this.platform.is('pwa');
  readonly isIos: boolean = this.platform.is('ios');
  readonly isDesktop: boolean = this.platform.is('desktop');
  readonly testUserCriOS: boolean = this.platform.testUserAgent('CriOS');
  readonly isAndroid: boolean = this.platform.is('android');

}